<div class="modal fade show d-block" id="storeDeletedModal" tabindex="-1" role="dialog" aria-labelledby="storeDeletedModalLabel" aria-hidden="true" style="background: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center p-4">
          <p class="processing-text">This Store is Permanently Deleted by Admin,</p>
          <p class="processing-text">Logging out of your account.</p>
        </div>
      </div>
    </div>
  </div>